import ReactCer from '../assets/png/ReactMeta.PNG'
export const achievementData = {
    bio : "Develop a passion for learning. If you do, you will never cease to grow. - Anthony J. D’Angelo",
    achievements : [
        {
            id : 1,
            title : 'React Basics',
            details : 'A React Basics course from Coursera',
            date : 'Apr 19, 2023',
            field : 'Coding ',
            image : ReactCer,
        },
        {
            id : 2,
            title : 'The Ultimate MySQL Bootcamp: Go from SQL Beginner to Expert',
            details : 'A MySQL course from Udemy',
            date : 'May 25, 2021',
            field : 'Database',
            image : 'https://udemy-certificate.s3.amazonaws.com/image/UC-91ae3ea2-39ee-4a57-bf23-d397aff0d9a7.jpg?v=1621951317000'
        },
      

    ]
}


// Do not remove any fields.
// Leave it blank instead as shown below.

/*

export const achievementData = {
    bio : "",
    achievements : []
}

*/